import React from "react";
import DashbordPageSection from "../sections/DashbordPageSection/Content";
const DashbordPage = () => {
  return <DashbordPageSection />;
};

export default DashbordPage;
